import React from "react";
import VScroll from "../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import NavigationSection from "../../../core/model2/navigation/navigation-section";


export type MenuComponentProps = {
    refScroll   : React.RefObject<VScroll>

    section     : NavigationSection

    noAnimation : boolean
}

export const EVENT_BUS_MENU_RERENDER = 'bus-menu-rerender'
export const EVENT_BUS_MENU_SORT_CHANGED = 'menu-sort-changed'
export const EVENT_BUS_MENU_SORT_RESET = 'menu-sort-reset'
